import { Stack, Typography } from '@mui/material';
import type { Currency } from '@vy/types';
import React from 'react';
import { Price } from '../../../../../../../components/design/Price';
import { LivePreviewContainerHeaderLabel } from './LivePreviewContainerHeaderLabel';
import { VyDivider } from '../../../../../../../components/new-design/atoms';

type LivePreviewContainerHeaderProps = {
  currency: Currency;
  itemsCount: number;
  totalAmount: number;
};

export const LivePreviewContainerHeader: React.FC<LivePreviewContainerHeaderProps> = ({
  currency,
  itemsCount,
  totalAmount,
}) => (
  <Stack direction="column" sx={{
    rowGap: 1
  }}>
    <Stack>
      <Typography
        variant="overline"
        sx={{
          color: "text.secondary",
          fontWeight: 300,
          textTransform: "uppercase"
        }}>
        Full Amount
      </Typography>
      <Price variant="h5" sx={{ fontWeight: 400 }}>
        {totalAmount}
      </Price>
    </Stack>
    <Stack
      direction="row"
      divider={<VyDivider orientation="vertical" />}
      sx={{
        display: "flex",
        padding: "12px 0",
        gap: "24px"
      }}>
      <Stack sx={{
        gap: "4px"
      }}>
        <LivePreviewContainerHeaderLabel title="Currency:" value={currency} />
        <LivePreviewContainerHeaderLabel title="Items:" value={`${itemsCount}`} />
      </Stack>
      <Stack>
        <LivePreviewContainerHeaderLabel
          title="Full Amount:"
          containerProps={{
            direction: 'column',
            sx: { gap: '4px' },
          }}
          render={({ align: _align, ...props }) => (
            <Stack direction="row" sx={{
              gap: "2px"
            }}>
              <Price currency={currency} {...props}>
                {totalAmount}
              </Price>
              <Typography {...props}>{currency}</Typography>
            </Stack>
          )}
        />
      </Stack>
    </Stack>
  </Stack>
);
